module.exports = __webpack_public_path__ + "img/reviewer2.f3037e0b.png";